import { FC } from "react";
import { useRouter } from "next/router";
import { FileAsset, HtmlAsset, LinkAsset, TextAsset, PromptAsset } from "./base";
import { AssetTypes } from "lib/types";
import { useLoggedinUser, usePack } from "lib/hooks";
import { isPreviewingPack } from "lib/utils";
import { usePackContext } from "domains/pack";
import { isEditable } from "./utils";
import { useDndAsset } from "domains/drag-and-drop";

export const Asset: FC<{ type: string }> = ({ type }) => {
  const { data: user } = useLoggedinUser();
  const { pathname } = useRouter();
  const { packId } = usePackContext();
  const { data: pack } = usePack(packId);
  const { asset } = useDndAsset();

  const canEdit = isEditable(asset, user, pack) && !isPreviewingPack(pathname);

  switch (type) {
    case AssetTypes.HTML:
      return <HtmlAsset isEditable={canEdit} />;
    case AssetTypes.LINK:
      return <LinkAsset isEditable={canEdit} />;
    case AssetTypes.FILE:
      return <FileAsset isEditable={canEdit} />;
    case AssetTypes.PROMPT:
      return <PromptAsset isEditable={canEdit}  />;
    case AssetTypes.TEXT:
      return <TextAsset isEditable={canEdit} />;
    default:
      return null;
  }
};
